module.exports = __webpack_public_path__ + "img/hr-green-small-grass-09.47150b73.png";